export default {"src":"/_next/static/media/GoutConditions.f52fd5d3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};